import ModalComponent from "components/Modals"
import TableComponent from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  getCodesList,
  hideAssignCodeModal,
  hideReassignCodeModal,
  hideReinstateCodeModal,
  openAssignCodeModal,
  openReassignCodeModal,
  openReinstateCodeModal,
} from "store/actions"
import AssignCodeModal from "./assignCodeModal"
import codesListColumns from "./codesListColums"
import CodesListFilterComponent from "./codesListFilterComponent"
import CreateUserModal from "./createUserModal"
import ReassignCodeModal from "./reassignCodeModal"
import ReinstateCodeModal from "./reinstateCodeModal"

const CodesList = ({
  codes,
  assignCodeModalIsOpen,
  openAssignCodeModal,
  hideAssignCodeModal,
  createUserModalIsOpen,
  reassignCodeModalIsOpen,
  openReassignCodeModal,
  hideReassignCodeModal,
  openReinstateCodeModal,
  hideReinstateCodeModal,
  reinstateCodeModalIsOpen,
  getCodesList,
}) => {
  const [formattedData, setFormattedData] = useState([])
  const [selectedItem, setSelectedItem] = useState(null)
  const [sortParams, setSortParams] = useState({
    bch: 0,
    o: "created_at",
    od: "desc",
    page: 1,
  })

  useEffect(() => {
    let hostCodes = codes?.data
    let finalData = []
    hostCodes?.forEach(x => {
      finalData?.push({ ...x, role: "Host" })
      if (x?.guestcodes && x?.guestcodes?.length > 0) {
        x?.guestcodes?.forEach(y => {
          finalData?.push({ ...y, role: "Guest" })
        })
      }
    })
    setFormattedData(finalData)
  }, [codes])

  const actions = [
    {
      name: "Reinstate",
      onClick: item => {
        setSelectedItem(item)
        openReinstateCodeModal()
      },
      icon: "mdi mdi-backup-restore font-size-16",
      checkIfDisabled: item => {
        return item?.user_id ? false : true
      },
    },
    {
      name: "Reassign",
      onClick: item => {
        setSelectedItem(item)
        openReassignCodeModal()
      },
      icon: "mdi mdi-account-convert-outline font-size-16",
      checkIfDisabled: item => {
        return item?.user_id ? false : true
      },
    },
    {
      name: "Assign",
      onClick: item => {
        setSelectedItem(item)
        openAssignCodeModal()
      },
      icon: "mdi mdi-account-arrow-left-outline font-size-16",
      checkIfDisabled: item => {
        return item?.user_id ? true : false
      },
    },
  ]

  const customRowStyle = row => {
    if (row?.role === "Host") {
      return { backgroundColor: "#34c38f" }
    }
  }

  const handlePageChange = page => {
    getCodesList({
      ...sortParams,
      page: page,
    })
    setSortParams({
      ...sortParams,
      page: page,
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getCodesList({
      ...sortParams,
      o: sortField,
      od: sortOrder,
      page: 1,
    })
    setSortParams({
      ...sortParams,
      o: sortField,
      od: sortOrder,
      page: 1,
    })
  }

  return (
    <React.Fragment>
      <CodesListFilterComponent />
      <TableComponent
        data={formattedData}
        columns={codesListColumns(actions)}
        rowStyle={row => customRowStyle(row)}
        hover={false}
        classes="table align-middle table-nowrap"
        onPageChange={handlePageChange}
        onTableSort={handleSort}
        paginationData={{
          current_page: codes?.current_page,
          last_page: codes?.last_page,
          total_items: codes?.total,
          items_per_page: codes?.per_page,
          from: codes?.from,
          to: codes?.to,
          first: 1,
        }}
      />
      <ModalComponent
        title="Assign Code"
        open={assignCodeModalIsOpen}
        onClose={hideAssignCodeModal}
      >
        <AssignCodeModal code={selectedItem} codesList={formattedData} />
      </ModalComponent>
      <ModalComponent
        title="Assign Code"
        open={createUserModalIsOpen}
        // onClose={hideAssignCodeModal}
      >
        <CreateUserModal />
      </ModalComponent>
      <ModalComponent
        title={`Reassign Code "${selectedItem?.code}"`}
        open={reassignCodeModalIsOpen}
        onClose={hideReassignCodeModal}
      >
        <ReassignCodeModal code={selectedItem} />
      </ModalComponent>
      <ModalComponent
        title={`Reinstate code "${selectedItem?.code}"`}
        open={reinstateCodeModalIsOpen}
        onClose={hideReinstateCodeModal}
      >
        <ReinstateCodeModal code={selectedItem} />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  codes: state.codes.codes,
  assignCodeModalIsOpen: state.codes.assignCodeModalIsOpen,
  createUserModalIsOpen: state.codes.createUserModalIsOpen,
  reassignCodeModalIsOpen: state.codes.reassignCodeModalIsOpen,
  reinstateCodeModalIsOpen: state.codes.reinstateCodeModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  openAssignCodeModal: () => dispatch(openAssignCodeModal()),
  hideAssignCodeModal: () => dispatch(hideAssignCodeModal()),
  openReassignCodeModal: () => dispatch(openReassignCodeModal()),
  hideReassignCodeModal: () => dispatch(hideReassignCodeModal()),
  openReinstateCodeModal: () => dispatch(openReinstateCodeModal()),
  hideReinstateCodeModal: () => dispatch(hideReinstateCodeModal()),
  getCodesList: values => dispatch(getCodesList(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CodesList)
